import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { VirtualConnectionsDisplayGridRowDataFragmentGql } from './VirtualConnectionsDisplayGridRowDataFragmentGql';

export const DatabaseDownstreamVirtualConnectionsFilteredByTableQueryGql: DocumentNode = gql`
query DatabaseDownstreamVirtualConnectionsFilteredByTableQuery(
  $tableId: ID!,
  $first: Int!,
  $offset: Int!,
  $orderBy: VirtualConnectionSortOrder!,
  $publishedConnectionsLineageEnabled: Boolean!,
) {
  tables(filter: { id: $tableId }) {
    downstreamVirtualConnectionsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...VirtualConnectionsDisplayGridRowDataFragment
      }
    }
    maxDownstreamDatasources: downstreamVirtualConnectionsConnection(
      orderBy: { field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC }
      first: 1
    ) {
      nodes {
        downstreamDatasourcesConnection { totalCount }
      }
    }
    maxDownstreamWorkbooks: downstreamVirtualConnectionsConnection(
      orderBy: { field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC }
      first: 1
    ) {
      nodes {
        downstreamWorkbooksConnection { totalCount }
      }
    }
  }
}
${VirtualConnectionsDisplayGridRowDataFragmentGql}
`;
